export default __webpack_public_path__ + "static/media/1.b1bf7cc7.png";